export default __webpack_public_path__ + "static/media/34.80ac3645.png";